import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";
import { SuccessStory } from "../types";

interface SuccessStoryCardProps {
  story: SuccessStory;
}

const SuccessStoryCard = ({ story }: SuccessStoryCardProps) => {
  return (
    <div className="bg-surface rounded-lg border border-border overflow-hidden hover:shadow-elevation-2 transition-all duration-300">
      <div className="h-48 overflow-hidden">
        <Image
          src={story.image}
          alt={story.alt}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-lg font-semibold text-foreground">
              {story.projectName}
            </h3>
            <p className="text-sm text-muted-foreground">{story.partnerName}</p>
          </div>
          <div className="px-3 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full">
            {story.collaborationType}
          </div>
        </div>

        <p className="text-sm text-muted-foreground mb-4 line-clamp-3">
          {story.testimonial}
        </p>

        <div className="flex items-center gap-4 mb-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-1">
            <Icon name="Clock" size={16} />
            <span>{story.duration}</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="Target" size={16} />
            <span>{story.outcome}</span>
          </div>
        </div>

        <div className="flex flex-wrap gap-2">
          {story.technologies.map((tech, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-muted text-xs text-foreground rounded"
            >
              {tech}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SuccessStoryCard;